import { useEffect, useState } from "react";
import * as d3 from "d3";

function Item (props) {
    const data = props.data.filter(el => el.test),
        getLabel = props.getLabel,
        colors = props.colors,
        prompt = props.prompt,
        image = props.image,
        tab = props.tab,
        index = props.index;

    // const answers = data.map(el => el.test[index])
    const participants = data.length

    const parsed = parseData()

    // function parseDataOld (data, index) {
    //     return Array.from(d3.rollup(data, v => v.length, d => d.test[index].answer), ([key, value]) => ({ 
    //         answer: key, 
    //         count: value,
    //         report_quality: answers.filter(el => el.answer === key && el.report_quality).length,
    //         report_problem: answers.filter(el => el.answer === key && el.report_problem).length,
    //     }));
    // }

    function parseData () {
        const filtered = [].concat(...data.map(el => el.test.filter(item => item.image === image)))
        return Array.from(d3.rollup(filtered, v => v.length, d => d.answer), ([key, value]) => ({ 
            answer: key, 
            count: value,
            report_quality: filtered.filter(el => el.answer === key && el.report_quality).length,
            report_problem: filtered.filter(el => el.answer === key && el.report_problem).length,
        }));
    }

    function drawTable (data) {
        if (data.length === 0) {
            d3.select('#item_rows_'+index)
                .selectAll('.table_row')
                .remove()
        } else {
    
            function colorCount(answer){
                if (['queer', 'nonbinary'].includes(prompt)) {
                    if (['gen02', 'gen20'].includes(answer)) return colors.wrong
                    else return colors.right
                } else {
                    if (answer === prompt) return colors.right
                    else {
                        const aF = +answer[4],
                            aM = +answer[3],
                            pF = +prompt[4],
                            pM = +prompt[3];
                        
                        if (Math.abs(aF - pF) + Math.abs(aM - pM) < 2) return colors.close
                        else return colors.wrong
                    }
                }
            }

            const sorted = data.sort((a, b) => d3.descending(a.count, b.count));
            
            d3.select('#item_rows_'+index)
                .selectAll('.table_row')
                .data(sorted)
                .join(
                    function(enter) {
                        const row = enter.append('div')
                            .attr('class', 'table_row')
                            .style('background-color', (d,i) => i%2===0 ? 'rgb(255,255,255,0.07)' : 'rgb(255,255,255,0.035)')
                            .style('opacity', 0)
    
                        row.append('div')
                            .attr('class', 'answer')
                            .style('width', tab.answer)
                            .html(d => getLabel(d.answer))

                        row.append('div')
                            .attr('class', 'count_number')
                            .style('width', tab.count_number)
                            .html(d => d.count)
    
                        const count = row.append('div')
                            .style('width', tab.count_rect)
    
                        count.append('div')
                            .attr('class', 'count_rect')
                            .style('width', d => d.count / participants * 9.5 + 'em')
                            .style('background-color', d => colorCount(d.answer))
    
                        row.append('div')
                            .attr('class', 'report_problem')
                            .style('width', tab.report)
                            .html(d => d.report_problem);
    
                        row.append('div')
                            .attr('class', 'report_quality')
                            .style('width', tab.report)
                            .html(d => d.report_quality);

                        row.transition().duration(1000).style('opacity', 1)
                    },
                    function (update) {
                        update
                            .style('opacity', 1);

                        update.select('.answer')
                            .html(d => getLabel(d.answer));

                        update.select('.count_number')
                            .html(d => d.count);
    
                        update.select('.count_rect')
                            .transition()
                            .duration(1000)
                            .ease(d3.easeBounce)
                            .style('width', d => d.count / participants * 9.5 + 'em')
                            .style('background-color', d => colorCount(d.answer))

                        update.select('.report_problem')
                            .html(d => d.report_problem);
    
                        update.select('.report_quality')
                            .html(d => d.report_quality);
    
                    },
                    function (exit) {
                        exit.transition()
                            .duration(1000)
                            .style('opacity', 0)
                            .transition()
                            .remove()
                    }
                )
        }
    }



    useEffect(() => {
        console.log(parsed)
        drawTable(parsed)
    });

  return (
    <div>
        {/* <h2 style={{margin: '0.5em'}}>{index}</h2> */}
        <div style={{
            display: 'flex',
            borderWidth: '0 0 1px 0',
            borderColor: '#222',
            borderStyle: 'solid'
            }}>
            <div id={"item_image_" + index}
                className="item_image"
                style={{
                    height: tab.image,
                    width: tab.image,
                    backgroundImage: 'url("./img/portraits_20250320/' + image + '"',
                    transition: 'all 1s ease',
                    borderRadius: 0,
                }}
            />
            <div 
                id={"item_rows_"+index} 
                className="table_rows" 
            />
        </div>
    </div>
  );
}

export default Item;
